import { ArrowRight, Stethoscope } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left: copy */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 mb-6 reveal">
              <span className="inline-flex h-1.5 w-1.5 rounded-full bg-[#3E615B]" />
              <span className="eyebrow">Radiologia di precisione · Bergamo</span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight font-light text-stone-900 leading-[1.05] reveal reveal-delay-1"
            >
              Precisione diagnostica,
              <br />
              <span className="text-[#3E615B] font-normal">cura per la persona.</span>
            </h1>

            <p className="mt-6 max-w-xl text-base sm:text-lg text-stone-600 leading-relaxed reveal reveal-delay-2">
              Sono la <strong className="font-medium text-stone-900">Dott.ssa Silvia Dal Bello</strong>, Medico Radiologo
              e Responsabile della Radiologia presso la Casa di Cura Palazzolo di Bergamo.
              Oltre quattordici anni di esperienza in <em>diagnostica per immagini</em> con una
              specifica competenza in Risonanza Magnetica body e senologia.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4 reveal reveal-delay-3">
              <Button
                asChild
                data-testid="hero-cta-primary"
                className="rounded-full bg-[#3E615B] hover:bg-[#2D4742] text-white px-7 py-6 text-sm"
              >
                <a href="#sedi" className="inline-flex items-center gap-2">
                  Prenota una visita
                  <ArrowRight size={16} />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                data-testid="hero-cta-secondary"
                className="rounded-full border-stone-300 text-stone-800 hover:bg-stone-100 px-7 py-6 text-sm"
              >
                <a href="#competenze" className="inline-flex items-center gap-2">
                  <Stethoscope size={16} />
                  Aree di competenza
                </a>
              </Button>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg reveal reveal-delay-4">
              <Stat value="14+" label="Anni di esperienza" />
              <Stat value="3" label="Sedi a Bergamo" />
              <Stat value="2007" label="Laurea in Medicina" />
            </div>
          </div>

          {/* Right: portrait */}
          <div className="lg:col-span-5 reveal reveal-delay-2">
            <div className="relative">
              <div className="absolute -inset-4 rounded-[2rem] bg-[#E9F0EE]/60 -z-10" />
              <div className="relative overflow-hidden rounded-[2rem] border border-stone-200 shadow-sm aspect-[4/5] bg-stone-100">
                <img
                  data-testid="hero-portrait"
                  src="https://customer-assets.emergentagent.com/job_radiolog-clinic/artifacts/yzx5ly0n_Silvia_Dal_Bello.jpg"
                  alt="Dott.ssa Silvia Dal Bello"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl border border-stone-200 shadow-sm px-5 py-4 max-w-[220px] hidden md:block">
                <p className="text-[11px] uppercase tracking-[0.2em] text-stone-500">
                  Formazione
                </p>
                <p className="mt-1 text-sm text-stone-900 font-medium leading-snug">
                  Addenbrooke's Hospital · University of Cambridge
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-display text-2xl md:text-3xl font-medium text-stone-900">
        {value}
      </div>
      <div className="text-xs uppercase tracking-[0.18em] text-stone-500 mt-1">
        {label}
      </div>
    </div>
  );
}
